export default __webpack_public_path__ + "744e147005cef1a6506850f0a0d60c7e.wav";